import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";

const initialFormData = {
  name: "",
  email: "",
  phone: "",
  eventType: "",
  numberOfGuests: "",
  eventDate: "",
  eventTime: "",
  zipCode: "",
  additionalInfo: "",
};

function CateringPage() {
  const [formData, setFormData] = useState(initialFormData);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const restaurantData = {
    phone: "973-350-6522",
    name: "A Plus Flavor",
    address: "677 Bergen St., Newark, NJ 07108",
    hours: "Tue-Sun: 10AM-8PM | Mon: Closed",
    socialLinks: {
      facebook:
        "https://www.facebook.com/profile.php?id=61576392401010",
      instagram:
        "https://www.instagram.com/aplusflavorrestaurant",
    },
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    console.log("Catering form submitted:", formData);

    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData(initialFormData);
    }, 3000);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* No per-page header here: TopBar/Navbar are global */}
      <div className="flex-1 bg-gradient-to-b from-gray-50 to-gray-100 py-12">
        <div className="max-w-5xl mx-auto px-4">
          {/* Hero */}
          <div className="text-center mb-12">
            <h2
              className="text-4xl font-bold text-black mb-4"
              style={{
                fontFamily: "'Signika Negative', sans-serif",
              }}
            >
              Let Us Cater Your Next Event
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              Enjoy the exotic tastes of authentic Haitian
              cuisine. We provide catering, delivery, setup, and
              cleanup services for small or large groups.
            </p>
            <div className="flex gap-6 justify-center flex-wrap">
              <div className="flex items-center gap-2">
                <span className="text-2xl">📦</span>
                <span className="text-gray-700 font-semibold">
                  Delivery
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-2xl">🎉</span>
                <span className="text-gray-700 font-semibold">
                  Setup
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-2xl">✨</span>
                <span className="text-gray-700 font-semibold">
                  Decoration
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-2xl">🧹</span>
                <span className="text-gray-700 font-semibold">
                  Cleanup
                </span>
              </div>
            </div>
          </div>

          {/* Contact Banner */}
          <div
            className="text-white rounded-lg p-8 mb-12 text-center"
            style={{ backgroundColor: "#f2340a" }}
          >
            <p className="text-xl font-bold mb-2">
              Ready to book your event?
            </p>
            <p className="text-lg mb-4">
              Call us directly or fill out the form below
            </p>
            <a
              href="tel:973-350-6522"
              className="text-2xl font-bold hover:underline"
            >
              📞 973-350-6522
            </a>
          </div>

          {/* Form */}
          <div
            className="bg-white rounded-xl shadow-lg p-8 border-t-4"
            style={{ borderTopColor: "#f2340a" }}
          >
            <h3
              className="text-2xl font-bold text-black mb-2"
              style={{
                fontFamily: "'Signika Negative', sans-serif",
              }}
            >
              Catering Request Form
            </h3>
            <p className="text-gray-600 mb-8">
              Please provide as much detail about your event as
              possible.
            </p>

            {submitted && (
              <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 rounded">
                <p className="text-green-700 font-semibold">
                  ✓ Thank you! We&apos;ve received your catering
                  request. We&apos;ll contact you shortly!
                </p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                    placeholder="John Doe"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                    placeholder="john@example.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                    placeholder="(973) 350-6522"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Event Type
                  </label>
                  <input
                    type="text"
                    name="eventType"
                    value={formData.eventType}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                    placeholder="Birthday, Wedding, Corporate..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Number of Guests
                  </label>
                  <input
                    type="number"
                    name="numberOfGuests"
                    value={formData.numberOfGuests}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                    placeholder="50"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Zip Code
                  </label>
                  <input
                    type="text"
                    name="zipCode"
                    value={formData.zipCode}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                    placeholder="07108"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Event Date
                  </label>
                  <input
                    type="date"
                    name="eventDate"
                    value={formData.eventDate}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Event Time
                  </label>
                  <input
                    type="time"
                    name="eventTime"
                    value={formData.eventTime}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Additional Info
                </label>
                <textarea
                  name="additionalInfo"
                  value={formData.additionalInfo}
                  onChange={handleInputChange}
                  rows={5}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg transition"
                  placeholder="Tell us about the menu, allergies, delivery/setup needs, etc."
                />
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="px-10 py-4 text-lg font-semibold uppercase tracking-wider rounded transition-all duration-300 hover:shadow-xl hover:-translate-y-1 text-white"
                  style={{ backgroundColor: "#f2340a" }}
                >
                  Submit Request
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer restaurantData={restaurantData} />
    </div>
  );
}

export default CateringPage;
